module.exports = __webpack_public_path__ + "public/img/名单管理.0abc27e4.png";